import { createContext } from 'react'

import { createImageCardStore } from '../store/createStore'

export const ImageCardContext = createContext<
  ReturnType<typeof createImageCardStore> | undefined
>(undefined)
